(function () {
  var script = document.currentScript;
  var headerId = script && script.dataset.headerId;
  var mainHeader = headerId ? document.getElementById(headerId) : null;
  if (!mainHeader) {
    mainHeader = document.querySelector('[class~="#header"][data-index-nav-immersive]');
  }
  if (!mainHeader) return;

  var utilityBar = document.querySelector('[class~="#utility-bar"]');
  var desktopMq = window.matchMedia('(min-width: 992px)');

  var SCROLL_HIDE_THRESHOLD = 8;
  var SCROLL_SHOW_THRESHOLD = 2;

  var isScrolled = false;
  var scrollTicking = false;

  function measureUtilityHeight() {
    if (!desktopMq.matches) {
      document.documentElement.style.setProperty('--utility-bar-height', '0px');
      return;
    }

    var height = 0;
    if (utilityBar) {
      height = Math.ceil(utilityBar.offsetHeight);
      if (height < 1) {
        var section = utilityBar.closest('.shopify-section');
        if (section) {
          height = Math.ceil(section.getBoundingClientRect().height);
        }
      }
    }

    if (height < 1) height = 36;
    document.documentElement.style.setProperty('--utility-bar-height', height + 'px');
  }

  function syncHeaderHeight() {
    var height = Math.floor(mainHeader.getBoundingClientRect().height);
    if (height > 0) {
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
  }

  function syncLayoutVars() {
    measureUtilityHeight();
    syncHeaderHeight();
  }

  function getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function resolveScrollState(scrollTop) {
    if (!isScrolled && scrollTop > SCROLL_HIDE_THRESHOLD) return true;
    if (isScrolled && scrollTop <= SCROLL_SHOW_THRESHOLD) return false;
    return isScrolled;
  }

  function applyScrollState(nextState) {
    if (nextState === isScrolled) return;
    isScrolled = nextState;
    document.body.classList.toggle('is-index-nav-scrolled', isScrolled);
  }

  function updateScrollState() {
    scrollTicking = false;
    applyScrollState(resolveScrollState(getScrollTop()));
  }

  function scheduleScrollUpdate() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(updateScrollState);
  }

  syncLayoutVars();
  updateScrollState();

  window.addEventListener('resize', syncLayoutVars);
  window.addEventListener('load', function () {
    syncLayoutVars();
    updateScrollState();
  });
  window.addEventListener('scroll', scheduleScrollUpdate, { passive: true });

  if (typeof ResizeObserver !== 'undefined') {
    var observer = new ResizeObserver(syncLayoutVars);
    observer.observe(mainHeader);
    if (utilityBar) observer.observe(utilityBar);
  }

  if (typeof desktopMq.addEventListener === 'function') {
    desktopMq.addEventListener('change', function () {
      syncLayoutVars();
      updateScrollState();
    });
  } else if (typeof desktopMq.addListener === 'function') {
    desktopMq.addListener(function () {
      syncLayoutVars();
      updateScrollState();
    });
  }
})();
